import { graphql } from '@/gql';
import type { AbTestUpdateInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';
import _ from 'lodash';

const props = [
  'delay',
  'description',
  'deactivateDate',
  'endAfterNumUsers',
  'endDate',
  'id',
  'name',
  'startDate',
  'status',
  'successConditions',
  'exclusiveKeys',
  'data',
  'type',
] as const;

export const abTestUpdate = async (abTestUpdate: AbTestUpdateInput) => {
  const response = await mutationExecute({
    variables: { abTestUpdate: _.pick(abTestUpdate, props) },
    mutation: graphql(`
      mutation abTestUpdate($abTestUpdate: AbTestUpdateInput!) {
        abTestUpdate(abTestUpdate: $abTestUpdate) {
          __typename
          id
          name
          type
          description
          status
          startDate
          endDate
          deactivateDate
          createdAt
          updatedAt
          delay
          endAfterNumUsers
          successConditions
          data
          exclusiveKeys
          abTestGroups {
            createdAt
            data
            description
            groupLabel
            groupType
            groupTarget
            associatedObjectType
            associatedObjectId
            winner
            id
            updatedAt
          }
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  if (!response.data?.abTestUpdate) {
    throw new Error('Unexpected empty response');
  }

  return response.data.abTestUpdate;
};
